/** App `ride_requests.product` and website bookings for admin ride tabs. */

export function normalizeRideProduct(ride) {
  return String(ride?.product || '').trim().toLowerCase();
}

/** City / daily product from the Saarthi rider app. */
export function isDailyProductRide(ride) {
  return normalizeRideProduct(ride) === 'daily';
}

/** Outstation, website “Book a taxi”, and other non-daily trips. */
export function isHireCarRide(ride) {
  return !isDailyProductRide(ride);
}

export function rideProductTabLabel(ride) {
  const product = normalizeRideProduct(ride);
  if (product === 'daily') return 'Instant ride';
  if (product === 'outstation') return 'Hire a car';
  if (product === 'website') return 'Website booking';
  if (!product) return 'Hire a car';
  return product.replace(/_/g, ' ');
}
